module.exports = __webpack_public_path__ + "img/GO.54bea13d.png";